import { Link } from "react-router-dom";
import { RankPanel } from "@/components/home/RankPanel";

/** The `member` tier can reach only `/profile`.
 *
 *  Deliberately a page, not a redirect: `/home` is unguarded on purpose and is
 *  the PageGuard fallback, so redirecting it would reintroduce the redirect
 *  chain that design exists to prevent. */
export function MinimalHome() {
  return (
    <div className="space-y-3 max-w-md">
    <div className="card px-5 py-8 flex flex-col items-center text-center max-w-md">
      <div className="text-sm font-medium text-slate-200">You're all set</div>
      <div className="text-[12.5px] text-slate-500 mt-1">
        Your account doesn't have any working pages enabled yet. An administrator
        can grant them from Role permissions.
      </div>
      <Link to="/profile" className="btn-secondary mt-4">
        Open your profile
      </Link>
    </div>
    {/* Self-hides on 403, so an account without board access is unchanged. */}
    <RankPanel />
    </div>
  );
}
